<template>
    <div
        v-bind:class="notificationClasses"
        class="card">
        <a
            v-bind:href="targetLink"
            class="dropdown-item notification-container">
            <div class="m-3">
                <div class="d-flex mb-1">
                    <div class="fw-bold text-truncate">
                        {{ notification.Title }}
                    </div>
                    <div
                        class="text-end flex-grow-1"
                        style="min-width: 25px">
                        {{ relativeTimestamp }}
                    </div>
                </div>
                <div style="white-space: normal">
                    {{ displayContent }}
                </div>
            </div>
        </a>
    </div>
</template>
<script>
    import { getRelativeTimestamp } from "Util/timestamp";
    const contentLengthLimit = 140;

    export default {
        props: {
            pageLoadTimeTicks: { type: Number, required: true },

            // Publication timestamp of the latest notification the logged in user
            // has seen. Used for determining whether this notification should be
            // considered new
            lastViewedNotificationTimestampTicks: { type: Number, required: true },

            notification: { type: Object, required: true }
        },
        data() {
            return {
                isNew: this.lastViewedNotificationTimestampTicks < this.notification.PublicationTimeUtcTicks
            };
        },
        computed: {
            relativeTimestamp() {
                return getRelativeTimestamp(this.pageLoadTimeTicks, this.notification.PublicationTimeUtcTicks);
            },
            displayContent() {
                return this.notification.Content.length > contentLengthLimit
                    ? `${this.notification.Content.substr(0, contentLengthLimit).trim()}...`
                    : this.notification.Content;
            },
            notificationClasses() {
                return this.isNew ? "notification-new" : "";
            },
            targetLink() {
                return this.notification.TargetLink.replace("(programId)", this.$app.ProgramId);
            }
        },
        watch: {
            lastViewedNotificationTimestampTicks() {
                if (this.lastViewedNotificationTimestampTicks >= this.notification.PublicationTimeUtcTicks) {
                    this.markNotificationSeen();
                }
            }
        },
        methods: {
            // Delay marking notification as new in the client
            // to allow the new notification animation to complete
            async markNotificationSeen() {
                await this.$app.timeout(3000);
                this.isNew = false;
            }
        }
    };
</script>
<style lang="scss" scoped>
    .notification-container {
        padding: 0;
    }

    .notification-new {
        animation: notification-new 2s ease-out 1;
    }

    @keyframes notification-new {
        from {
            background: var(--bs-primary-200);
        }
        to {
            background: var(--bs-white);
        }
    }
</style>
